import { AnyAction } from "redux";
import { MemberState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): MemberState => ({
    extraSim: {},
    selectedStep: "phoneNumber",
});

const reducer = (state = initialState(), action: AnyAction): MemberState => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_GET_EXTRA_SIM_PRICES):
            return {
                ...state,
                extraSim: {
                    dataSimPrice: action.payload.extraDataSimPrice,
                    tvillingSimPrice: action.payload.extraTvillingSimPrice,
                    hasExistingExtraDataSim: action.payload.hasExistingExtraDataSim,
                },
            };
        case AT.CHECKOUT_SET_SELECTED_MEMBER_STEP:
            return {
                ...state,
                selectedStep: action.payload.selectedStep,
            };
        default:
            return state;
    }
};

export default reducer;
